// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'acuminproLightWebfont', 'acuminproLightWebfont Fallback'"},"className":"__className_14ff11","variable":"__variable_14ff11"};